import { Component, Inject, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { Automation } from '@vendasta/automata';
import {
  Filter2TableModule,
  TABLE_DEFINITION,
  VaFilteredMatTableService,
  VaTableSortService,
} from '@vendasta/va-filter2-table';
import { CurrentlyWaitingFiltersService } from './currently-waiting-filters.service';
import { CurrentlyWaitingTableService } from './currently-waiting-table.service';
import { tableDefinitionFactory } from './table-model';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { UsersService } from '../../data-services/users.service';
import { AutomationViewService } from '../../automation/automation-view.service';

interface DialogData {
  automation: Automation;
  workflowStepId: string;
}

@Component({
  templateUrl: './currently-waiting-dialog.component.html',
  styleUrls: ['./currently-waiting-dialog.component.scss'],
  providers: [
    CurrentlyWaitingTableService,
    CurrentlyWaitingFiltersService,
    VaFilteredMatTableService,
    VaTableSortService,
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {} },
    UsersService,
    AutomationViewService,
  ],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TranslateModule, MatDialogModule, Filter2TableModule, MatButtonModule],
})
export class CurrentlyWaitingDialogHelperComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    readonly dataService: CurrentlyWaitingTableService,
  ) {}

  ngOnInit(): void {
    this.dataService.initialize(this.data.automation, this.data.workflowStepId);
  }
}

@Component({
  template: ` <ng-container *ngComponentOutlet="component; injector: injector"></ng-container> `,
  imports: [CommonModule],
})
export class CurrentlyWaitingDialogComponent implements OnInit {
  injector: Injector;
  component = CurrentlyWaitingDialogHelperComponent;

  constructor(
    public dialogRef: MatDialogRef<CurrentlyWaitingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private readonly parentInjector: Injector,
  ) {}

  ngOnInit(): void {
    this.injector = Injector.create({
      providers: [
        { provide: 'entityType', useValue: this.data.automation.entityType },
        { provide: CurrentlyWaitingFiltersService, useClass: CurrentlyWaitingFiltersService },
        {
          provide: TABLE_DEFINITION,
          useFactory: tableDefinitionFactory,
          deps: [CurrentlyWaitingFiltersService, 'entityType'],
        },
      ],
      parent: this.parentInjector,
    });
  }
}
